import { render, staticRenderFns } from "./TabShareWebLink.vue?vue&type=template&id=2f0db79d&"
import script from "./TabShareWebLink.vue?vue&type=script&lang=js&"
export * from "./TabShareWebLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports